// 标签模板
<template>
  <div style="position: relative">
    <el-form
      ref="formSysPost"
      :model="formSysPost"
      label-width="100px"
      :size="defaultFormItemSize"
      label-position="right"
      @submit.native.prevent
    >
      <filter-box :item-width="350">
        <!-- <el-form-item label="岗位名称" prop="formFilter.postName">
          <el-input
            class="filter-item"
            v-model="formSysPost.formFilter.postName"
            :clearable="true"
            placeholder="岗位名称"
          />
        </el-form-item>
        <el-button
          slot="operator"
          type="default"
          :plain="true"
          :size="defaultFormItemSize"
          @click="onReset"
          >重置</el-button
        >
        <el-button
          slot="operator"
          type="primary"
          :plain="true"
          :size="defaultFormItemSize"
          @click="refreshFormSysPost(true)"
          >查询</el-button
        > -->
        <el-button
          slot="operator"
          type="primary"
          size="small"
          @click="addItem()"
        >
          新建
        </el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table
          ref="sysPost"
          :data="tableData"
          :size="defaultFormItemSize"
          header-cell-class-name="table-header-gray"
        >
          <el-table-column
            label="序号"
            header-align="center"
            align="center"
            type="index"
            width="55px"
            :index="formSysPost.sysPost.impl.getTableIndex"
          />
          <el-table-column label="标签模板名称" prop="modelName">
          </el-table-column>
          <el-table-column label="模板类型" prop="modelType">
            <template slot-scope="scope">
              {{ typeObj[scope.row.modelType] }}
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button @click.stop="editItem(scope.row)" type="text">
                编辑
              </el-button>
              <el-button
                class="table-btn delete"
                @click.stop="deleteItem(scope.row)"
                type="text"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px">
          <el-pagination
            background
            :total="pagination.total"
            :current-page="pagination.current"
            :page-size="pagination.size"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @size-change="handleSizeChange"
            @current-change="currentChange"
          >
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>

    <el-dialog
      :title="title === 1 ? '新增' : '编辑'"
      :visible.sync="dialogVisible"
      @close="diaClose"
      width="600px"
    >
      <AddOrEdit
        v-if="title"
        @diaClose="diaClose"
        @onAdd="onAdd"
        @onUpdate="onUpdate"
        :row="row"
      />
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import rules from "@/utils/validate.js";
import {
  DropdownWidget,
  TableWidget,
  UploadWidget,
  ChartWidget,
} from "@/utils/widget.js";
import AddOrEdit from "./indexInfo.vue";

export default {
  name: "LabelModel",
  props: {},
  components: {
    AddOrEdit,
  },
  // mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data() {
    return {
      formSysPost: {
        formFilter: {
          postName: undefined,
        },
        formFilterCopy: {
          postName: undefined,
        },
        sysPost: {
          impl: new TableWidget(
            this.loadSysPostWidgetData,
            this.loadSysPostVerify,
            true,
            false,
            "level",
            1
          ),
        },
        isInit: false,
      },
      typeObj: {
        1: "原材料",
        2: "模具",
        3: "成品",
      },
      modelTypeArr: [
        { label: "原材料", value: 1 },
        { label: "模具", value: 2 },
        { label: "成品", value: 3 },
      ],

      tableData: [],
      pagination: {
        size: 10,
        total: 0,
        page: 1,
        // current: 1
      },
      dialogVisible: false,
      title: 1, // 1、新增 2、编辑 3、详情
      row: {},
    };
  },
  methods: {
    async getTableData() {
      let { data } = await this.$api.getPrintModelList({
        pageParam: {
          pageNum: this.pagination.page,
          pageSize: this.pagination.size,
        },
      });
      this.tableData = data.dataList;
      this.pagination.total = data.totalCount;
    },
    // 重置
    reset() {
      this.tableParams = {};
      this.getTableData();
    },
    addItem() {
      this.row = {};
      this.title = 1;
      this.dialogVisible = true;
    },
    editItem(row) {
      this.row = row;
      this.title = 2;
      this.dialogVisible = true;
    },
    diaClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.title = null;
      }, 100);
    },
    // 新增
    async onAdd(params) {
      await this.$api.AddPrintModel(params);
      this.$message({
        message: "新增成功",
        type: "success",
      });
      this.dialogVisible = false;
      this.getTableData();
    },

    // 更新
    async onUpdate(params) {
      await this.$api.UpdatePrintModel(params);
      this.$message({
        message: "更新成功",
        type: "success",
      });
      this.dialogVisible = false;
      this.getTableData();
    },

    // 删除
    async onDel(row) {
      await this.$api.DelPrintModel({ id: row.id });
      this.$message({
        message: "删除成功",
        type: "success",
      });
      this.getTableData();
    },

    deleteItem(row) {
      this.$alert("是否删除当前数据？", "提示", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            this.onDel(row);
          }
        },
      });
    },

    // 切换page
    currentChange(val) {
      // console.log("val", val);
      this.changePagination({
        page: val,
        size: this.pagination.size,
      });
    },
    // 切换size
    handleSizeChange(val) {
      // console.log("val", val);
      this.changePagination({
        page: 1,
        size: val,
      });
    },
    changePagination(val) {
      this.pagination = {
        ...this.pagination,
        ...val,
      };
      this.getTableData();
    },
  },
  mounted() {
    this.getTableData();
  },
  activated() {
    this.getTableData();
  },
  watch: {},
};
</script>
